<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--main" :class="[footerClasses, {'app-page': isAppPage}]">
    <div style="width: 100%;">
      <div style="height: 90px; width: 100%; padding: 1rem">
        <div style="height: 100%; width: 100%;">
          <div id="public-digi-logo-container">
            <img v-if="windowWidth >= 700" style="height: 100%;" src="@/assets/images/DigiCampus Logo High-small.png"/>
            <img v-else style="height: 100%;" src="@/assets/images/DigiCampus Only Logo.png"/>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed flex" style="z-index: 21;" >
        <div class="fixed flex" id="profile-search-upload">
            <div id="home-container" class="relative mr-2 overflow-hidden" onclick="window.open('/home', '_self');">
                <feather-icon id="learn-now-icon" icon="HomeIcon" svg-classes="stroke-current"></feather-icon>
                <span>Home</span>
            </div>
            <div id="profile-container" class="relative text-center flex">
                <feather-icon id="profile-icon" icon="UserIcon" svg-classes="stroke-current"></feather-icon>
                <div id="logged-in_username">{{user_displayName}}</div>
            </div>
        </div>
    </div>
    <div>
      <div class="router-content mt-0" style="max-width: 450px;margin: auto;">
        <transition :name="routerTransition">
          <div class="router-header flex flex-wrap items-center mb-6" v-if="$route.meta.breadcrumb || $route.meta.pageTitle">
          </div>
        </transition>
        <div class="content-area__content">
          <back-to-top bottom="5%" visibleoffset="500" v-if="!hideScrollToTop">
            <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg" />
          </back-to-top>
          <transition :name="routerTransition" mode="out-in">
            <router-view @changeRouteTitle="changeRouteTitle"></router-view>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheFooter from "../components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import BackToTop from "vue-backtotop";

export default {
  data() {
    return {
      footerType: themeConfig.footerType || "static",
      routerTransition: themeConfig.routerTransition || "none",
      routeTitle: this.$route.meta.pageTitle,
      disableCustomizer: themeConfig.disableCustomizer,
      windowWidth: window.innerWidth, //width of windows
      hideScrollToTop: themeConfig.hideScrollToTop,
      disableThemeTour: themeConfig.disableThemeTour
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
  },
  computed: {
    isAppPage() {
      if (this.$route.path.includes("/apps/")) return true;
      else return false;
    },
    isThemeDark() {
      return this.$store.state.theme == "dark";
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.sidebarWidth == "default") return "content-area-default";
      else if (this.sidebarWidth == "reduced") return "content-area-reduced";
      else if (this.sidebarWidth) return "content-area-full";
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static"
      };
    },
    user_displayName() {
      return JSON.parse(localStorage.getItem("userInfo")).displayName != null ? JSON.parse(localStorage.getItem("userInfo")).displayName.split('(')[0] : JSON.parse(localStorage.getItem("userInfo")).displayName;
    },
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
        this.$store.dispatch("updateSidebarWidth", "no-sidebar");
        this.disableThemeTour = true;
      } else if (this.windowWidth < 1200) {
        this.$store.dispatch("updateSidebarWidth", "reduced");
      } else {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    },
    changeBackgroundColor(color) {
      var bodyEl = document.getElementsByTagName('body')[0];

      bodyEl.style.background = "linear-gradient(180deg, rgba(56, 57, 57, 1) 0%, rgba(25, 25, 35, 1) 15%, rgba(25, 25, 35, 1) 100%) fixed";
    },
  },
  components: {
    TheFooter,
    BackToTop
  },
  created() {
    this.setSidebarWidth();
  },
  mounted() {
    var self = this;

    self.$store.dispatch("updateTheme", "dark");
    self.changeBackgroundColor();

    self.$nextTick(() => {
      window.addEventListener("resize", self.handleWindowResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", self.handleWindowResize);
  }
};
</script>
<style lang="scss">

</style>